import {Component, ElementRef, ViewChild, OnInit} from '@angular/core';
import {AppConfig, LayoutService} from './service/app.layout.service';
import {AuthService} from "../_services/auth_service";
import {NavigationEnd, Router} from "@angular/router";
import {HttpResponse} from "@angular/common/http";
import {LanguageService} from "../_services/language_service";
import { TranslateModule } from '@ngx-translate/core';
import {etichettaRuolo} from "../_helpers/ruoli";
import {AvatarInizialiComponent} from "../_components/avatar-iniziali/avatar-iniziali.component";


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl: './app.topbar.component.css',
})
export class AppTopbarComponent implements OnInit {
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    config!: AppConfig;


    selectedLanguage: string = 'it'; // Valore di default

    subscription: any;
    public nome: string = "";
    public email: string = "";
    public ruolo: string = "";
    public medico_id: string = "";
    public dashboard_link = "/";

    showDialog: boolean = false;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private authService: AuthService,
        private router: Router,
        private languageService: LanguageService
    ) {
        this.subscription = this.layoutService.configUpdate$.subscribe(
            (config) => {
                this.config = config;
            }
        );


    }
    onLanguageChange(event: Event): void {
        const lang: string = (event.target as HTMLSelectElement).value;
        this.languageService.changeLanguage(lang);
    }


    ngOnInit() {
        const savedLanguage = localStorage.getItem('lang');
        if (savedLanguage) {
            this.selectedLanguage = savedLanguage;
        }

        this.authService.getUserData().subscribe({
            next: (response: HttpResponse<any>) => {

                this.nome = response.body.nome;
                this.email = response.body.email;
                this.ruolo = response.body.ruolo;

                // Il selettore di lingua e' offerto al solo paziente: chi non
                // lo ha va riportato all'italiano, altrimenti un browser in
                // inglese lo lascerebbe in una lingua che non puo' cambiare.
                this.languageService.allineaAlRuolo(this.ruolo);

                if (this.ruolo == 'medico') {
                    this.dashboard_link = '/medico';
                }
                else if (this.ruolo == 'paziente') {
                    this.dashboard_link = '/paziente';
                }
                else {
                    this.dashboard_link = '/';
                }
            }
        });
    }

    /** Il ruolo come va scritto a video: "Specialista", non "medico". */
    /* Sul telefono il pulsante del menu utente mostra solo le iniziali («EF»): il
       nome accessibile deve contenerle, perche' chi comanda a voce dice quello che
       vede (WCAG 2.5.3). Prima era solo «Menu utente». */
    get inizialiUtente(): string {
        return AvatarInizialiComponent.inizialiDi(this.nome);
    }

    get ruoloEtichetta(): string {
        return etichettaRuolo(this.ruolo);
    }

    /**
     * Apertura e chiusura del menu a cassetto dal tasto ≡.
     *
     * Chi naviga da tastiera deve trovarsi dentro il cassetto appena si apre —
     * altrimenti il fuoco resta sulla barra e per raggiungere le voci va
     * attraversato tutto quello che sta in mezzo — e deve ritrovare il tasto ≡
     * quando lo chiude, che e' il punto da cui era partito (21/09/2026).
     *
     * Il fuoco si sposta dopo il giro di disegno, perche' prima il cassetto non
     * e' ancora nel documento.
     */
    onMenuButtonClick() {
        const eraAperto = this.layoutService.state.staticMenuMobileActive;
        const cassetto = !this.layoutService.isDesktop();
        this.layoutService.onMenuToggle();

        // Da desktop il tasto apre e chiude la barra laterale fissa, che non e'
        // un cassetto: il fuoco non si tocca.
        if (!cassetto) {
            return;
        }

        if (eraAperto) {
            this.mobileMenuButton?.nativeElement.focus();
            return;
        }

        setTimeout(() => {
            const primaVoce = document.querySelector<HTMLElement>(
                '.layout-sidebar .layout-menu ul a'
            );
            primaVoce?.focus();
        });
    }

    dialog() {
        this.showDialog = true;
    }

    logout() {
        this.closeTopbarMenu();
        this.authService.logout().subscribe({
            next: (response: HttpResponse<any>) => {
                const statusCode = response.status;
                if (statusCode == 200) {
                    //this.router.navigate(['/login']);
                    window.location.href = 'https://doctorium.it';
                }
            },
            error: (error) => {
                //  this.messageService.add({ key: 'centerTop', severity: 'error', summary: 'Errore', detail: error.error.message, life: 3000 });
            }
        });
    }

    goToProfilo() {
        this.closeTopbarMenu();
        if (this.ruolo === 'medico') {
            this.router.navigate(['/profilomedico']);
        } else if (this.ruolo === 'paziente') {
            this.router.navigate(['/profilopaziente']);
        }

    }

    goToCambiapassword() {
        this.closeTopbarMenu();
        this.router.navigate(['/cambiapassword']);
    }

    goToModificaConsensi() {
        this.closeTopbarMenu();
        this.router.navigate(['/modificaconsensi']);
    }

    goToPrivacyConsulto() {
        this.closeTopbarMenu();
        this.router.navigate(['/privacy-consulto']);
    }
    isInternalLink(url: string): boolean {
        return !/^https?:\/\//.test(url);  // Ritorna true se NON è un link esterno
    }

    closeTopbarMenu() {
        const menus = document.querySelectorAll('.layout-topbar-menu');
        menus.forEach((menu: any) => {
            menu.classList.add('hidden');
        });
    }

}
